type ParameterlessConstructor<T> = { new (): T; prototype: T };
function isUndefinedOrNull(value: any): value is undefined | null {
    return value === undefined || value === null;
}

export function statusGetter<T, S>(
    self: T,
    selfConstructor: ParameterlessConstructor<T> & {
        statusPrototype: (s: S) => T;
    },
    statusConstructor: any,
): S {
    for (const key in statusConstructor) {
        // go thru all statuses
        if (isNaN(Number(key))) {
            // get how this status should look like
            const statusPrototype = selfConstructor.statusPrototype(statusConstructor[key]);

            // check if the status props are equal
            let isEqual = true;
            for (const k in statusPrototype) {
                if (isEqual && isUndefinedOrNull(self[k]) != isUndefinedOrNull(statusPrototype[k])) {
                    isEqual = false;
                }
            }

            if (isEqual) {
                return statusConstructor[key];
            }
        }
    }

    throw new Error("status was not recognized");
}
